exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ITtCUQNY5WZhYPxI2IObp{padding:2.14286rem 2.14286rem 1.42857rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"BottomButtons": "ITtCUQNY5WZhYPxI2IObp"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/BottomButtons/style.postcss
// module id = 2011
// module chunks = 0